import AppView from "../../app-view";
import KnowledgeBaseDetailContent from "./components/KnowledgeBaseDetailContent";
import { useTranslation } from "react-i18next";
import { namespace } from "@common/config/constants";

const KnowledgeBaseDetail = () => {
  const { t } = useTranslation(namespace);

  return <AppView title={t('knowledgeBase.detail.pageTitle')} showHeader={false}>
    <KnowledgeBaseDetailContent />
  </AppView>
};

export default KnowledgeBaseDetail; 
